import { render, staticRenderFns } from "./CaretUpFill.vue?vue&type=template&id=5f40a682"
import script from "./CaretUpFill.vue?vue&type=script&lang=js"
export * from "./CaretUpFill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports